var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carousel_wrap"},_vm._l((_vm.footerBanner),function(item,index){return _c('a',{key:index,style:({backgroundImage: `url(${item.image})`}),attrs:{"href":"/"}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }